const Color = {
  containerBorderTop: '#62ab28',
  backgroundColor: '#50cfe5',
  baseFontColor: '#383838',
  orange: '#ee9d3f',
  green: '#62ab28',
  pink: '#ec8d7c',
  pageTitleColor: '#008035',
  gray: '#d5d1cf',
  lightGray: '#e7e7e7',
  red: '#e00',
  lightGray2: '#f1efee',
}

export default Color
